import userStore from './../shared/UserStore';

class CountryService {
    private static countries = {
        '1': 'sv',
        '2': 'fi',
        '3': 'fr',
        '4': 'es'
    };

    private static countryIds = {
        sv: 1,
        fi: 2,
        fr: 3,
        es: 4
    };

    private static phoneCountryCodes = {
        sv: 'SE',
        fi: 'FI',
        fr: 'FR',
        es: 'ES'
    };

    private static tranlationKey = {
        '1': 'country/sweden',
        '2': 'country/finland',
        '3': 'country/france',
        '4': 'country/spain'
    };

    public static getDefaultOrImpersonatedCountryId(): number {
        let impersonatedCountry = userStore.fetchCountryImpersonationFromSessionStorage();
        let user = userStore.fetchUserFromLocalStorage();

        if (impersonatedCountry) {
            return impersonatedCountry.id;
        } else if (user) {
            return user.details.country;
        } else {
            return 0;
        }
    }

    public static getDefaultOrImpersonatedCountryCode(): string {
        let countryId = this.getDefaultOrImpersonatedCountryId();

        if (!countryId) {
            return '';
        } else {
            return this.mapCountryIdToString(countryId);
        }
    }

    public static getCountryCodeForPhoneNumberInput(): string {
        let country = this.getDefaultOrImpersonatedCountryCode();
        return this.phoneCountryCodes[country];
    }

    private static mapCountryIdToString(countryId: number): string {
        if (countryId && countryId in this.countries) {
            return this.countries[countryId.toString()];
        } else {
            return null;
        }
    }

    public static getAvailablePhoneCountryCodes() {
        let countryCodes = [];
        for (let key in this.phoneCountryCodes) {
            countryCodes.push(this.phoneCountryCodes[key]);
        }

        return countryCodes;
    }

    public static mapCountryCodeToId(countryCode: string): number {
        return this.countryIds[countryCode];
    }

    public static getCountryTranslationKey(countryId: number): string {
        return this.tranlationKey[countryId.toString()];
    }
}

export default CountryService;
